<div class="csm-report">

  <div class="opposite">

    <select class="type-selector" (change)="selectAcademicYear($event)">
      <option value="">All academic years</option>
      @for (year of academicYears; track year) {
        <option [value]="year.formatted_year">{{year.formatted_year}}</option>
      }
    </select>

    <div class="report-name">CSM Report - {{clientName}} {{codeDescription}}</div>


  </div>


  @if (loading) {
    <div class="table-container">
      @for (i of [1,2,3,4,5]; track i) {
        <div class="skeleton-container">
          <div class="skeleton-row-flex">
            <div class="skeleton-bar" style="width: 40px; margin-right: 20px;"></div>
            <div class="skeleton-bar" style="width: 80%;"></div>
          </div>
        </div>
      }
    </div>
  }

  @if (!loading) {
    <div class="table-container mat-elevation-z8">
      <mat-table #table [dataSource]="dataSource">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <!-- Value Column -->
        <ng-container matColumnDef="value">
          <mat-header-cell *matHeaderCellDef> Question </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.value}} </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
        </mat-row>
      </mat-table>
    </div>
  }


  <div class="toolbar">

    <button (click)="cancel()">Cancel</button>

    <button (click)="download()">Download HTML Report</button>

    <button (click)="downloadExcel()">Download Excel Report</button>
  </div>
</div>